const GET_NEWS_LIST_REQUESTED = "GET_NEWS_LIST_REQUESTED";
const GET_NEWS_LIST_SUCCEEDED = "GET_NEWS_LIST_SUCCEEDED";
const GET_NEWS_LIST_FAILED = "GET_NEWS_LIST_FAILED";

const GET_NEWS_LIST_FOR_USER_REQUESTED = "GET_NEWS_LIST_FOR_USER_REQUESTED";
const GET_NEWS_LIST_FOR_USER_SUCCEEDED = "GET_NEWS_LIST_FOR_USER_SUCCEEDED";
const GET_NEWS_LIST_FOR_USER_FAILED = "GET_NEWS_LIST_FOR_USER_FAILED";

export { GET_NEWS_LIST_REQUESTED, GET_NEWS_LIST_SUCCEEDED, GET_NEWS_LIST_FAILED, GET_NEWS_LIST_FOR_USER_REQUESTED, GET_NEWS_LIST_FOR_USER_SUCCEEDED, GET_NEWS_LIST_FOR_USER_FAILED };
